const TOKEN_KEY = 'admin_token'
const USERNAME_KEY = 'admin_username'

export const getToken = () => localStorage.getItem(TOKEN_KEY) || ''
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token)
export const clearToken = () => localStorage.removeItem(TOKEN_KEY)

export const getStoredUsername = () => localStorage.getItem(USERNAME_KEY) || ''
export const setStoredUsername = (username) => localStorage.setItem(USERNAME_KEY, username)
export const clearStoredUsername = () => localStorage.removeItem(USERNAME_KEY)
